'use es6';

import { useEffect, useState, useRef } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { jsx as _jsx } from "react/jsx-runtime";
const withTransientToolbar = (editor, renderToolbar, removeToolbar) => WrappedComponent => {
  // Events that cause the toolbar to be mounted / render
  const focusEvents = editor.settings.focusEvents || 'focus';

  // Events that cause the toolbar to be hidden either by animated away or unmounting
  const blurEvents = editor.settings.blurEvents || 'blur remove';
  editor.on(focusEvents, renderToolbar);
  editor.on('remove', removeToolbar);
  function TransientToolbar(props) {
    const [hasFocus, setHasFocus] = useState(false);
    const mountedRef = useRef(false);
    useEffect(() => {
      // When the transient toolbar mounts we can assume that it has focus
      // And so we can trigger the "in" animation
      setHasFocus(true);
      const handleFocus = () => {
        if (mountedRef.current) {
          setHasFocus(true);
        }
      };
      const handleBlur = () => {
        if (mountedRef.current) {
          setHasFocus(false);
        }
      };
      mountedRef.current = true;
      editor.on(focusEvents, handleFocus);
      editor.on(blurEvents, handleBlur);
      return () => {
        mountedRef.current = false;
        editor.off(focusEvents, handleFocus);
        editor.off(blurEvents, handleBlur);
      };
    }, []);
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      useAnimatedToolbar: true,
      hasFocus: hasFocus
    }));
  }
  TransientToolbar.displayName = `TransientToolbar(${getComponentName(WrappedComponent)})`;
  return TransientToolbar;
};
export default withTransientToolbar;